import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} Labubu Wallpapers. Created with ♥ by a fan.</p>
    </footer>
  );
};

export default Footer;
